import React, { forwardRef } from 'react';
import theme from '../../theme';

const Input = forwardRef(({ 
  type = 'text',
  label,
  error,
  helper,
  icon,
  size = 'md',
  fullWidth = true,
  className = '',
  containerClassName = '',
  style = {},
  ...props 
}, ref) => {
  const sizes = {
    sm: {
      padding: `${theme.spacing[2]} ${theme.spacing[3]}`,
      fontSize: theme.typography.fontSize.sm,
    },
    md: {
      padding: `${theme.spacing[3]} ${theme.spacing[4]}`,
      fontSize: theme.typography.fontSize.base,
    },
    lg: {
      padding: `${theme.spacing[4]} ${theme.spacing[5]}`,
      fontSize: theme.typography.fontSize.lg,
    },
  };
  
  const containerStyles = {
    width: fullWidth ? '100%' : 'auto',
    display: 'inline-block',
  };
  
  const inputContainerStyles = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  };
  
  const inputStyles = {
    width: '100%',
    backgroundColor: theme.colors.bg.input,
    color: theme.colors.text.primary,
    border: `1px solid ${error ? theme.colors.error : theme.colors.border.default}`,
    borderRadius: theme.borderRadius.md,
    outline: 'none',
    transition: `all ${theme.transitions.base}`,
    ...sizes[size],
    paddingLeft: icon ? `calc(${sizes[size].padding} + 24px)` : sizes[size].padding,
    ...style,
  };
  
  const labelStyles = {
    display: 'block',
    marginBottom: theme.spacing[2],
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.medium,
    color: theme.colors.text.primary,
  };
  
  const helperStyles = {
    marginTop: theme.spacing[1],
    fontSize: theme.typography.fontSize.sm,
    color: error ? theme.colors.error : theme.colors.text.muted,
  };
  
  const iconStyles = {
    position: 'absolute',
    left: theme.spacing[3],
    color: theme.colors.text.muted,
    pointerEvents: 'none',
  };

  return (
    <div className={`castle-input-wrapper ${containerClassName}`} style={containerStyles}>
      {label && <label style={labelStyles}>{label}</label>}
      <div style={inputContainerStyles}>
        {icon && <span style={iconStyles}>{icon}</span>}
        <input
          ref={ref}
          type={type}
          className={`castle-input castle-input-${size} ${className}`}
          style={inputStyles}
          onFocus={(e) => {
            e.target.style.borderColor = theme.colors.border.focus;
          }}
          onBlur={(e) => {
            e.target.style.borderColor = error ? theme.colors.error : theme.colors.border.default;
          }}
          {...props}
        />
      </div>
      {(error || helper) && (
        <p style={helperStyles}>{error || helper}</p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;